module.exports = __webpack_public_path__ + "static/img/m10.01454e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m10.png
// module id = KBqd
// module chunks = 12